import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../../../core';
import { IntegrationUnidadeNegocio } from '../integration-unidade-negocio';

@Injectable({
    providedIn: 'root'
})
export class IntegrationUnidadeNegocioHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegration()}/unidadenegocio`;
    }

    /** Executa a integração de leitura das unidades de negócio com os sistemas ERP's */
    execReadIntegration(entity: IntegrationUnidadeNegocio): Observable<string> {
        // Params
        let params = new HttpParams();
        if (entity) {
            params = entity.createParams(params);
        }

        return this.customHttp.post<string>(this.pathApi, null, {params, responseType: 'text'});
    }
}
